import React from 'react';
import Chip from '@material-ui/core/Chip';
import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles({
  main: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: -8,
    marginBottom: -8
  },
  chip: {margin: 4}
});

const SimpleChipField = ({record, source}) => {
  const classes = useStyles();
  if (!record) return null;

  let labelText = record;
  if (source && typeof record === 'object' && record !== null && source in record) {
    labelText = record[source];
  } else if (typeof record === 'object' && record !== null) {
    labelText = record.key || record.name || record.title || Object.values(record)[0] || '';
  }

  if (labelText === null || labelText === undefined) {
    return null;
  }

  if (typeof labelText === 'object') {
    labelText = String(labelText);
  }

  return (
    <span className={classes.main}>
      <Chip key={String(labelText)} className={classes.chip} label={String(labelText)} />
    </span>
  );
};

SimpleChipField.defaultProps = {
  addLabel: true
};

export default SimpleChipField;
